module.exports = __webpack_public_path__ + "img/news-default.5d7a4c96.jpg";